module.exports = __webpack_public_path__ + "static/media/alissa.0a8c867b.jpg";